import { MICROSOFT_LINK_SCANNER_MESSAGE_PATTERN } from "@/lib/errors/microsoft-link-scanner-noise/constants";

/**
 * True for the unhandled `Object Not Found Matching Id:N, MethodName:update,
 * ParamCount:N` rejection from Microsoft's CefSharp-based link scanners.
 *
 * The scanner rejects with a string, not an Error, so the event has no stack
 * frames. Requiring that keeps the rule from hiding a real error that happens
 * to carry the same text.
 */
export function isMicrosoftLinkScannerNoise(
  message: string | undefined,
  stack: string | undefined,
): boolean {
  if (
    !message ||
    !MICROSOFT_LINK_SCANNER_MESSAGE_PATTERN.test(message.trim())
  ) {
    return false;
  }

  if (!stack) {
    return true;
  }

  return !stack.split("\n").some((line) => line.trim().startsWith("at "));
}
